import { render, staticRenderFns } from "./news-item.vue?vue&type=template&id=766d96d5&"
import script from "./news-item.vue?vue&type=script&lang=ts&"
export * from "./news-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports